<script setup lang="ts">
defineProps({
  label: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <dl class="settings-detail-list">
    <dt v-if="label || $slots.label">
      <div class="settings-details-label">
        <span>{{ label }}</span>
        <slot name="label"></slot>
      </div>
    </dt>
    <dd>
      <div class="settings-details">
        <slot></slot>
      </div>
    </dd>
  </dl>
</template>

<style lang="scss" scoped>
@use '@clovyr/bed/styles/vendor/bootstrap/scss/bootstrap';
@use '@clovyr/bed/styles/core';
@use 'src/styles/core/page';
@use 'src/styles/core/vertical-spacing';
@use 'styles/core/colors';

.settings-detail-list {
  &:not(:first-child) {
    margin-top: 1.25rem;
  }
  .settings-details-label {
    color: colors.color(grey, secondary);
    font-size: 0.75rem;
    line-height: 1.125rem;
  }
}
</style>
